import SupervisorLayout from '../../components/layout/SupervisorLayout';
import { FAQList } from '../../components/FAQList';

export default function SupervisorFAQPage() {
  return (
    <SupervisorLayout>
      <div className="p-4 sm:p-6 max-w-3xl mx-auto">
        <FAQList />
      </div>
    </SupervisorLayout>
  );
}
